@if (sideMediaType === mediaTypes.NONE) {
  @if (item[side === 'front' ? 'frontText' : 'backText']) {
    <ng-scrollbar class="flex-grow-1" thumbClass="custom-scrollbars" visibility="hover">
      <div class="content-wrapper flex-grow-1 d-flex flex-column align-items-center justify-content-center">
        <div class="content ck-text" [innerHTML]="item[side === 'front' ? 'frontText' : 'backText'] | safeHtml" [autoTextDirection]="!!isTranslation" [autoTextDirectionValue]="item[side === 'front' ? 'frontText' : 'backText']" [rtl]="slide?.langcode" [padding]="slide?.spacing"></div>
      </div>
    </ng-scrollbar>
  }
}

@if (item[side === 'front' ? 'frontVideo' : 'backVideo'] || item[side === 'front' ? 'frontEmbedVideo' : 'backEmbedVideo']; as video) {
  <lib-video
    #videoEl
    [style.height.px]="element.nativeElement.offsetHeight || 300"
    class="flip-card__video"
    [embedVideo]="item[side === 'front' ? 'frontEmbedVideo' : 'backEmbedVideo']"
    [src]="item[side === 'front' ? 'frontVideo' : 'backVideo'] | videoPresign | async"
    [loop]="video?.autoplayLoopMode"
    [autoplay]="video?.autoplayLoopMode"
    [hideControls]="video?.autoplayLoopMode"
    [showThumbnailsForEmbed]="true"
    (started)="onMediaStart()">
  </lib-video>
  @if (!mediaStarted && !video?.autoplayLoopMode) {
    <div class="start-media-overlay" (click)="videoEl.startVideo()">
      <mat-icon>play_arrow</mat-icon> Play video
    </div>
  }
}

@if (item[side === 'front' ? 'frontAudio' : 'backAudio']; as audioFile) {
  @if (!item[side === 'front' ? 'frontMediaBackground' : 'backMediaBackground']) {
    <mat-icon class="microphone-icon" svgIcon="lms-microphone" [class.white]="isDarkBackground"></mat-icon>
  }
  <lib-flipcard-audio
    [src]="audioFile | preSignedUrl : entityTypeId.PARAGRAPH : bundleType.FLIPCARD: (side === 'front' ? fieldName.AWS_FILE : fieldName.AWS_FILE_BACK) | async"
    [invert]="isRtl">
  </lib-flipcard-audio>
}

<div class="buttons-wrapper" (click)="stopPropagation($event)">
  <div class="icon-button" (click)="emitFlip()">
    <div class="icon-button__icon">
      <lib-icon icon="arrows-counter-clockwise"></lib-icon>
    </div>
  </div>
  @if (canEdit) {
    <div class="icon-button" (click)="emitOrientation()">
      <div class="icon-button__icon">
        <mat-icon class="orientation-icon" [svgIcon]="'lms-card-' + (item.orientation === 'portrait' ? 'portrait' : 'landscape')"></mat-icon>
      </div>
    </div>
    <div class="icon-button" (click)="emitEdit()">
      <div class="icon-button__icon">
        <mat-icon class="edit-icon" svgIcon="lms-edit"></mat-icon>
      </div>
    </div>
    <div class="icon-button" (click)="emitRemove()">
      <div class="icon-button__icon">
        <mat-icon class="bin-icon" svgIcon="lms-bin"></mat-icon>
      </div>
    </div>
    <ng-content select="[drag-handle]"></ng-content>
  }
</div>